import {Auth, AuthError, signOut} from "firebase/auth";
import {useMutation, UseMutationResult} from "@tanstack/react-query";

const useSignOut: (auth: Auth) => UseMutationResult<void, AuthError, void> = (
  auth,
) =>
  useMutation<void, AuthError, void>({
    mutationFn: () => {
      return signOut(auth);
    },
  });

export default useSignOut;
